import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as AdoptableBuyer } from './AdoptableBuyer';
import { default as AdoptableBuyerBranched } from './AdoptableBuyer__exclusive_gifts';
export default withFeatureBranch({
    exclusive_gifts: AdoptableBuyerBranched
})(AdoptableBuyer);
